export const EMAIL_REPLY_FORM_MODE = {
  forward: 'forward',
  reply: 'reply',
  replyAll: 'replyAll',
}
